var render = function render(){var _vm=this,_c=_vm._self._c;return _c('oct-dialog',{staticClass:"ss-category-selector",attrs:{"full":"","title":"その他","icon":'arrow-left'},on:{"dismiss":_vm.$_octPrototypeView_goBack}},[_c('oct-list',{attrs:{"title":"カテゴリーを選択"}},_vm._l((_vm.items),function(item){return _c('oct-list-item',{key:item.id,attrs:{"icon":item.icon,"title":item.name},nativeOn:{"click":function($event){return _vm.$router.push({
        path: `categories/${item.id}`,
        query: _vm.$route.query
      })}}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }